<template>
  <div id="ContactForm">
    <h2 class="page-title">Contact Me</h2>
    <form class="contact-form" @submit.prevent="sendMail">
      <div class="form-group">
        <label for="msg-name">Name</label>
        <input
          type="text"
          id="msg-name"
          class="form-control"
          v-model="contactFormData.name"
        />
        <p class="validation-msg" v-if="nameError">Required*</p>
      </div>
      <div class="form-group">
        <label for="msg-email">Email</label>
        <input
          type="text"
          id="msg-email"
          class="form-control"
          v-model="contactFormData.email"
        />
        <p class="validation-msg" v-if="emailError">Incorrect email.</p>
      </div>

      <div class="form-group">
        <label for="msg-message">Message</label>
        <textarea
          rows="7"
          id="msg-message"
          class="form-control"
          v-model="contactFormData.message"
        ></textarea>
        <p class="validation-msg" v-if="messageError">Required*</p>
      </div>
      <div class="form-result">
        <p class="alert alert-success" v-if="success && !error">
          Message sent successfully.
        </p>
        <p class="alert alert-error" v-if="!success && error">
          Message failed.
        </p>
      </div>
      <div class="form-group">
        <button type="submit" class="send-btn button btn-filled-white">
          Send
        </button>
      </div>
    </form>
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer";
import axios from "axios";

export default {
  name: "ContactForm",
  data: function () {
    return {
      contactFormData: {
        name: "",
        email: "",
        message: "",
      },
      emailError: false,
      nameError: false,
      messageError: false,
      reg: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      success: false,
      error: false,
    };
  },
  components: { Footer },
  methods: {
    sendMail: async function () {
      let { name, email, message } = this.contactFormData;

      if (name == "") {
        this.nameError = true;
        return;
      } else {
        this.nameError = false;
      }

      if (email == "" || !this.reg.test(email)) {
        this.emailError = true;
        return;
      } else {
        this.emailError = false;
      }

      if (message == "") {
        this.messageError = true;
        return;
      } else {
        this.messageError = false;
      }

      let payload = { name, email, message };
      const url =
        "https://us-central1-shani-life-coaching.cloudfunctions.net/sendEmailContactForm";

      try {
        let res = await axios.post(url, payload);
        
        if (res.data.success) {
          this.success = true;
          this.resetForm();
        } else {
          this.error = true;
        }
      } catch (err) {
        console.log(err);
        this.error = true;
      }
    },
    resetForm: function () {
      this.contactFormData = {
        name: "",
        email: "",
        message: "",
      };
    },
  },
};
</script>

<style scoped lang="scss">
#ContactForm {
  padding: 5em 2em;
  text-align: center;
}
.contact-form {
  margin: auto;
  padding: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;

  @media screen and (min-width: 481px) {
    width: 90%;
  }

  @media screen and (min-width: 576px) {
    width: 65%;
  }

  @media screen and (min-width: 768px) {
    width: 50%;
  }

  @media screen and (min-width: 992px) {
    width: 40%;
  }
}

.form-control {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

input[type="text"].form-control {
  margin: 8px 0;
  display: inline-block;
}

textarea.form-control {
  resize: none;
}

.send-btn {
  width: 50%;
}
.btn {
  cursor: pointer;
  padding: 8px 10px;
  outline: none;
  border: none;
  font-size: 16px;
  width: 100%;
  border-radius: 4px;
  text-align: center;
}
.validation-msg {
  font-size: 12px;
  text-align: left;
  color: #ff2121;
}
.alert {
  padding: 0 10px;
}
.alert-success {
  color: #3be249;
}
.alert-error {
  color: #ff2121;
}
</style>
